import { SORT_MODES } from '../constants/filters'
import { VERIFICATION_STATUSES } from '../constants/verificationStatuses'

export const QueryKeys = {
  search: (params = { page: 1 }) => ['search', params],
  notifications: (userType) => ['notifications', userType],
  categories: () => ['categories'],
  listCategories: () => ['listCategories'],
  category: (id) => ['categories', id],
  verificationFee: () => ['verificationFee'],
  categoryProducts: (categoryId, type, page = 1) => ['categoryProducts', categoryId, type, page],
  products: () => ['products'],
  retailProducts: (params = {}) => ['retailProducts', params],
  wholesellerProducts: (params = {}) => ['wholesellerProducts', params],
  topRetailers: () => ['topRetailers'],
  newProducts: () => ['newProducts'],
  topSellingProducts: () => ['topSellingProducts'],
  promotions: () => ['promotions'],
  topWholesalers: () => ['topWholesalers'],
  bidsList: (params = {}) => ['customerBidRequests', params],
  bidDetails: (bidId) => ['bidDetails', bidId],
  retailerProducts: (params = {}) => ['retailerProducts', params],
  listConversationMessages: (conversationId, userType) => [
    'conversation',
    conversationId,
    userType,
  ],
  listMessages: (params = { page: 1 }) => ['messages', params],

  authBase: () => ['auth'],
  authUser: () => ['auth', 'user'],
  authPermissions: () => ['auth', 'permissions'],

  retailersList: (id, page = 1) => ['retailers', id, page],
  wholesalersList: (id, page = 1) => ['wholesalers', id, page],
  retailerShopDetails: (retailerId) => ['retailers', retailerId, 'shop'],
  retailerShop: (retailerSlug, page = 1) => ['retailerShop', retailerSlug, page],
  retailerShopById: (userType, activeUserId) => ['retailerShop', userType, activeUserId],

  productFinderDetail: (id) => ['customerProductFinderDetail', id],
  paymentDetails: (id) => ['paymentDetails', id],

  productsByCategory: (categoryId) => ['products', 'category', categoryId],

  productsSearch: (id) => ['products', 'search', id],
  retailersSearch: (id) => ['retailers', 'search', id],
  wholesalersSearch: (id) => ['wholesalers', 'search', id],
  listShopProducts: (shopSlug, page = 1, category = '', isRetailer = false) => [
    'shopProducts',
    shopSlug,
    page,
    category,
    isRetailer,
  ],
  shopDetails: (shopId) => ['shopDetails', shopId],
  myShopDetails: (userType) => ['myShopDetails', userType],

  favoriteRetailers: (page) => ['favoriteRetailers', page],

  retailerBidRequests: (bidRequestType, page) => ['retailerBidRequests', bidRequestType, page],
  retailerBidRequestById: (id) => ['retailerBidRequestById', id],
  shopProductDetails: (productId, userType) => ['products', 'product', userType + productId],
  shopVerificationDetails: (id) => ['shopVerificationDetails', id],
  retailerBidRequestDetails: (requestId) => ['retailerBidRequests', requestId],
  messages: () => ['messages'],
  customerConversations: (targetId, contextType, contextId) => [
    'customerConversations',
    targetId,
    contextId,
    contextType,
  ],
  wholesalerConversationsList: (targetId) => ['wholesalerConversationsList', targetId],
  availableProducts: (params = {}) => ['availableProducts', params],

  adminWholesellerDetails: (id) => ['admin', 'wholeseller', id],
  adminListRetailers: (params = { page: 1, sortMode: SORT_MODES.LATEST.key }) => [
    'adminListRetailers',
    params,
  ],
  adminRetailerDetails: (id) => ['admin', 'retailerDetails', id],
  adminListCustomers: (params = { page: 1 }) => ['adminListCustomers', params],
  adminCustomerDetails: (id) => ['admin', 'customerDetails', id],
  adminListWholesellers: (
    params = {
      page: 1,
      sortMode: SORT_MODES.LATEST.key,
    }
  ) => ['adminListWholesellers', params],
  adminListShopVerifications: (
    params = {
      page: 1,
      sortMode: SORT_MODES.OLDEST.key,
      status: VERIFICATION_STATUSES.submitted.value,
    }
  ) => ['adminListVerifications', params],
  adminShopVerificationDetails: (id) => ['admin', 'shopVerificationDetails', id],
  adminListPromotions: (params = { page: 1 }) => ['adminListPromotions', params],
  adminPromotionDetails: (id) => ['admin', 'promotionDetails', id],
  adminListSubscriptions: (params) => ['adminListSubscriptions', params],

  wholesellersMessagesById: (conversationId) => ['conversation', conversationId],
  retailersMessagesById: (conversationId) => ['conversation', conversationId],
  adminSupportTicketDetails: (ticketId) => ['adminSupportTicketDetails', Number(ticketId)],
  userSubscriptions: () => ['userSubscriptions'],
  adminSupportTicketsStats: () => ['adminSupportTicketsStats'],
  adminSupportTickets: (params = { page: 1, sortMode: SORT_MODES.LATEST.key }) => [
    'adminSupportTickets',
    params,
  ],
  adminReportsTickets: (params = {}) => ['adminReportsTickets', params],
  adminReportStats: () => ['adminReportStats'],

  shopDocuments: (userType) => ['shopDocuments', userType],
  requiredDocuments: (userType) => ['requiredDocuments', userType],
  supportTickets: (params = { page: 1 }) => ['supportTickets', params],
  supportTicketDetails: (ticketId) => ['supportTicketDetails', ticketId],
  retailerShopStats: (retailerId) => ['retailerShopStats', retailerId],

  adminReportTicketById: (id) => ['adminReportTicketById', id],
  subscriptionPlans: () => ['subscriptionPlans'],
  adminSubscriptionStats: () => ['adminSubscriptionStats'],
  adminSubscriptionTiers: () => ['subscriptionTiers'],
}

export const IGNORE_LOADING_QUERY_KEYS = [
  QueryKeys.notifications,
  QueryKeys.supportTickets,
  QueryKeys.supportTicketDetails,
  QueryKeys.listMessages,
  QueryKeys.listConversationMessages,
  QueryKeys.bidDetails,
  QueryKeys.retailerBidRequests,
  QueryKeys.paymentDetails,
].map((key) => key()[0])
